import { render, staticRenderFns } from "./Histogram.vue?vue&type=template&id=93ad1db8&scoped=true&"
import script from "./Histogram.vue?vue&type=script&lang=ts&"
export * from "./Histogram.vue?vue&type=script&lang=ts&"
import style0 from "./Histogram.vue?vue&type=style&index=0&id=93ad1db8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ad1db8",
  null
  
)

export default component.exports